export default function StartPage() {
    const header: HTMLElement | null = document.querySelector("header");
    const heroSliderBlock: HTMLDivElement | null = document.querySelector<HTMLDivElement>(".HeroSliderBlock");

    const isHome = header?.getAttribute("data-ishome")?.toString().toLowerCase() === "true";
    if (!isHome) return;

    if (header && heroSliderBlock) {
        const originalPaddingTop = parseFloat(getComputedStyle(heroSliderBlock).paddingTop) || 0;

        const overlapHeroSliderBlockWithHeaderForTransparentEffect = () => {
            const headerHeight = header.offsetHeight;
            heroSliderBlock.style.marginTop = `-${headerHeight}px`;
            heroSliderBlock.style.paddingTop = `${originalPaddingTop + headerHeight}px`;
        };

        overlapHeroSliderBlockWithHeaderForTransparentEffect();
        window.addEventListener("resize", overlapHeroSliderBlockWithHeaderForTransparentEffect);
    }
}
